import React from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
import { LayoutProps } from '@/types/types';
type Props = LayoutProps & {
  children: React.ReactNode;
  size?:
    | ''
    | 'large'
    | 'medium'
    | 'small'
    | 'auto'
    | 'size_700'
    | 'full'
    | 'lg'
    | 'modal'
    | 'md'
    | 'sm';
};

export const Content = ({ children, size = '' }: Props) => {
  const style = classNames(styles.content, styles[size]);
  return <div className={style}>{children}</div>;
};
